/** In-app / embedded browsers where Firebase popup OAuth cannot return the session. */
export function shouldUseRedirectAuth(): boolean {
    if (typeof navigator === 'undefined') return false;

    const ua = navigator.userAgent || '';

    if (/WhatsApp|Instagram|FBAN|FBAV|Twitter|Line\/|LinkedInApp|Snapchat|Pinterest/i.test(ua)) {
        return true;
    }

    if (/Android/i.test(ua) && /;\s*wv\)|WebView/i.test(ua)) {
        return true;
    }

    // iOS embedded WebViews (not standalone Safari)
    if (/iPhone|iPad|iPod/i.test(ua) && /AppleWebKit/i.test(ua) && !/Safari/i.test(ua)) {
        return true;
    }

    return false;
}
